// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2rkPm","disabled":"FileBtn_disabled__2rVjT","warn":"FileBtn_warn__t2K7Z","fade":"FileBtn_fade__1QruI"};